import type { WidgetDefinition } from "@nexus/widget-sdk";
import widgetModule from ".";

export const definition: WidgetDefinition = {
  id: "metric-summary",
  module: widgetModule,
  catalog: {
    description:
      "Several figures of one metrics collection in one compact band: an EIS gauge with its monthly trend and the key KPIs.",
    domain: "kpis",
    visual: "KPI band",
    purposes: ["live", "reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "content", skeleton: "kpis" },
  defaultLayoutClassName: "col-span-12",
};
